import React from 'react';
import MLTooltip from '../Tooltip/Tooltip';
import './MultiSegmentLinearProgress.module.scss';

const MultiSegmentProgressBar = ({ segments }) => {
  return (
    <div className="flex items-center relative w-full max-w-[300px] h-4 rounded-[15px] overflow-hidden border-[var(--Grey-50)] border">
      {segments.map((segment, index) => (
        <MLTooltip
          tooltipPlacement="top"
          tooltipTitle={`${segment.status} : ${segment.count}`}
        >
          <div
            key={index}
            style={{ width: segment.percentCount }}
            className={`h-full ${segment.status.replaceAll(' ', '-')}`}
          ></div>
        </MLTooltip>
      ))}
    </div>
  );
};

export default MultiSegmentProgressBar;
